/** 前端二次校验：前加签未完成时，原审批人不可操作 */
export function isApproveActionableForUser(process, approveTasks, userId) {
  if (!process || process.status !== 'pending' || !userId) return false;

  const stepId = process.current_step_id || null;
  const myPending = (approveTasks || []).filter(
    (t) => t.status === 'pending'
      && String(t.assignee_user_id) === String(userId)
      && (!stepId || !t.step_id || t.step_id === stepId)
  );
  if (!myPending.length) return false;

  const myTask = myPending[0];
  if (myTask.add_sign_type === 'pre') return true;

  const prePending = (approveTasks || []).some(
    (t) => t.status === 'pending'
      && t.add_sign_type === 'pre'
      && (!stepId || t.step_id === stepId)
  );
  return !prePending;
}

export function resolveShowApprovalActions(process, approveTasks, userId, apiCanApprove, options = {}) {
  if (!apiCanApprove) return false;
  if (options.adminActing) return true;
  return isApproveActionableForUser(process, approveTasks, userId);
}

export function resolveApproveBlockedHint(process, approveTasks, userId, apiCanApprove, options = {}) {
  if (options.adminActing) return null;
  if (apiCanApprove || !process || process.status !== 'pending' || !userId) return null;

  const stepId = process.current_step_id || null;
  const hasMyPending = (approveTasks || []).some(
    (t) => t.status === 'pending'
      && String(t.assignee_user_id) === String(userId)
      && (!stepId || !t.step_id || t.step_id === stepId)
  );
  if (!hasMyPending) return 'only_current';

  const prePending = (approveTasks || []).some(
    (t) => t.status === 'pending'
      && t.add_sign_type === 'pre'
      && (!stepId || t.step_id === stepId)
  );
  if (prePending) return 'wait_pre_add_sign';
  return 'only_current';
}
